import React from 'react'
import "./../styles/article.css";

const Recipes = () => {
    return (
        <div className="card">
            <div className="Home__container">
                <div className="article-border">
                    <div className="article-container">
                        <h1 className='article-mainheading'>Show Choir’s Culinary Harmony: Recipes from Coast to Coast</h1>


                        <img className='full-width-img' src='images/recipes/i1.jpg' />

                        <h2 style={{ textAlign: 'center' }} className='sub-head mt-10 mb-20'>After Finals Party</h2>

                        <p className='mb-10'>From January through April, my weekends transform into a whirlwind of sequins, harmonies, and camaraderie with my show choir family. It all started with the parents of my daughter’s show choir in Indiana, but as the season unfolded and the competitions kept us crossing paths with the same schools, something magical happened—we all became one big extended family.</p>
                        <p className='mb-20'>By day, we're friendly competitors, cheering on our kids as they dazzle under the stage lights. But after finals? That’s when the real fun begins! We turn into a party-hopping, snack-sharing community, bouncing from room to room, sampling the goodies everyone brought along. The laughter is endless as we trade stories of the day's blunders—like the first-year move-in crew accidentally setting up the tallest risers in the front row. (You can always spot the rookies!)</p>

                        <p className='mb-20'>It’s not just about our own kids; we lift each other’s choirs up, celebrating the artistry and hard work that bring us all together. In this world of music and movement, we’re truly in it together.</p>

                        <p className='mb-20'>And because no competition weekend is complete without its share of culinary treasures, I’ve gathered some of my favorite post-show treats (and their recipes!) to share with you below. Whether you’re a seasoned show choir parent or just curious about the magic, these goodies will make you feel like part of the family.</p>

                        <p className='mb-20'>-Michael Clevenger, Show Choir Dad Indianapolis, Indiana</p>



                        <img className='full-width-img mb-20' src='images/recipes/1.png' />

                        <img className='full-width-img mb-20' src='images/recipes/2.png' />

                        <img className='full-width-img mb-20' src='images/recipes/3.png' />

                        <img className='full-width-img mb-20' src='images/recipes/4.png' />

                        <img className='full-width-img mb-20' src='images/recipes/5.png' />

                        <img className='full-width-img mb-20' src='images/recipes/6.png' />

                        <img className='full-width-img mb-20' src='images/recipes/7.png' />

                        <img className='full-width-img mb-20' src='images/recipes/8.png' />

                        <img className='full-width-img mb-20' src='images/recipes/9.png' />

                        <img className='full-width-img mb-20' src='images/recipes/10.png' />

                        <img className='full-width-img mb-20' src='images/recipes/11.png' />

                        <img className='full-width-img mb-20' src='images/recipes/12.png' />

                        <img className='full-width-img mb-20' src='images/recipes/13.png' />

                        <img className='full-width-img mb-20' src='images/recipes/14.png' />

                        <img className='full-width-img mb-20' src='images/recipes/15.png' />

                        <img className='full-width-img mb-20' src='images/recipes/16.png' />

                        <img className='full-width-img mb-20' src='images/recipes/17.png' />

                        <img className='full-width-img mb-20' src='images/recipes/18.png' />



                        <h2 style={{ textAlign: 'center' }} className='sub-head'>Are You the Show Choir World's
                            Best-Kept Culinary Secret?</h2>


                        <p>You’re the master of the irresistible treat, the dish everyone craves, or the dip that disappears in minutes. While your child rehearses late into Thursday night, you're busy creating your signature masterpiece. Come Saturday, it’s neatly packed in your cooler, ready for the big trip to the contest.</p>

                        <div className='img-bg-art'>
                            <img className='full-width-img' src='images/recipes/i2.jpg' />
                        </div>


                        <p className='mb-20'>Between Prelims and Finals, you slip away to your hotel, retrieve your specialty from the cooler, and set up the crockpot you cleverly stashed in your suitcase. With everything plugged in and warming up, you head back to the competition, where whispers of <i>“Did they bring it this week?”</i> fill the air. With a nod and a room number, you become the unofficial hero of Finals night.</p>

                        <p className='mb-20'>Your child’s choir places second, but it’s your room that everyone flocks to afterward—ready to celebrate and devour your legendary creation. Yet, somehow, you’ve managed to keep the recipe a closely guarded secret. Until now.</p>

                        <h2 className='sub-head'>The Show Choir World Is Waiting for You!</h2>

                        <p className='mb-20'>It’s time to share your culinary genius with fellow show choir fans! Head over to the Show Choir Chef section on the BetweenChoirs <a href='https://www.facebook.com/profile.php?id=61571698236116' target='_blank'>Facebook page</a> and let the world in on your delicious secret. Post your recipe—name it, list the ingredients, and include the preparation or cooking instructions. Don’t forget to tell us who you are, where you’re from, and the name of your child’s choir. And, of course, upload a picture of your dish so everyone can admire (and drool over) your creation.</p>

                        <p>Who knows? Your recipe might even get featured on the page for show choir enthusiasts everywhere to celebrate. So, what are you waiting for? Let’s get cooking!</p>















                    </div>

                    <div className='article-ad'>
                        <a href='https://www.nationalscholasticmusiciansawards.com/' target='_blank'>
                            <img src='images/nsma.png' />
                        </a>
                    </div>
                    <div className='nsma-text'>
                        <a href='https://www.nationalscholasticmusiciansawards.com/' target='_blank'>
                            <h2>Check Out</h2>
                            <h3 className='nsmah3'>NationalScholasticMusiciansAwards.com</h3>

                            <h4 className='nsmah4'>NationalScholastic</h4>
                            <h4 className='nsmah4'>MusiciansAwards.com</h4>
                        </a>

                    </div>


                </div>
            </div>
        </div>
    )
}

export default Recipes